<template>
    
    <v-container >
                    <v-row>
                    <v-col cols=12 sm="12" lg="12"  class="p-5 text-center" >
                        <div class="text-h3 search-hero__title">Ready to upskill or retrain?<br/>We've got you covered.</div>
                    </v-col>
                    </v-row>  
                    <v-row>
                    <v-col cols=12  sm="12" lg="4" class="p-5" >
                            <v-text-field
                            filled
                            rounded
                            solo
                            clearable
                            v-model="keyword"
                            label="Keyword/Title"
                            placeholder="Search"
                            v-on:keyup.enter="searchCourses"
                            ></v-text-field>
                    </v-col>
                    <v-col cols=12  sm="12" lg="4" class="p-5" >
                            <v-autocomplete
                            filled
                            rounded
                            solo
                            v-model="location"
                            label="Location"
                            placeholder="Location"
                            :items="locations"
                            clearable
                            v-on:keyup.enter="searchCourses"
                            ></v-autocomplete>
                    </v-col>
                    <v-col cols=12  sm="12" lg="4" >
                        <v-select
                            filled
                            rounded
                            solo
                            :items="categories"
                            v-model="category"
                            label="Category"
                            clearable
                            v-on:keyup.enter="searchCourses"
                            ></v-select>
                    </v-col>
                    
                    </v-row>
                    <v-row>
                    <v-col cols="12" sm="12" md="12" class="p-5 text-center">
                        <v-btn color="primary" class="search-submit" :height="isPhone ? 56 : undefined" :block="isPhone" @click="searchCourses">
                        <v-icon left>mdi-magnify</v-icon>
                        Search Courses
                        </v-btn>
                    </v-col>
                    </v-row>
                    
                </v-container>
</template>
<script>
  import LocationSelect from '@/Shared/LocationSelect'
  
  export default {
    props: {
      locations: Array,
      baseurl: String,
      startKeyword: String,
      startLocation: String,
      startCategory: String,
      categories: Array
    },
    components: {
    },
    computed: {
        isPhone() {
            return this.$vuetify.breakpoint.xsOnly;
        },
    },
    watch: {
        startKeyword: function () {
            this.keyword = this.startKeyword;
        },
        startLocation: function () {
            this.location = this.startLocation;
        },
        startCategory: function () {
            this.category = this.startCategory;
        },
    },
    data() {
        return {
            tab: null,
            keyword: this.startKeyword,
            location: this.startLocation ? this.startLocation : "",
            category: this.startCategory ? this.startCategory : "",
        }
    },
    methods: {
        searchCourses() {
            /*this.$inertia.get(this.baseurl+'/search/course', 
                {keyword: this.keyword, location: this.location, category: this.category}, 
                {}) */

            var result = this.categories.filter(obj => {
                return obj.value === this.category
            })

            var searchObj = {}
            if (this.keyword)
                searchObj.keyword = this.keyword
            if (this.location && this.location !== 'Ireland')
                searchObj.location = this.location

            if (result && result[0] && result[0].alias)
            {
                this.$inertia.get(this.baseurl+'/courses/'+result[0].alias, 
                searchObj, 
                {})
            }
            else
            {
                this.$inertia.get(this.baseurl+'/search/course', 
                searchObj, 
                {})
            }
        }
    }
  }
  </script>

<style scoped type="text/css">
/* `rounded` gives the inputs a full pill; 12px sits better with the rest of
   the UI. Keeping the prop preserves the inputs' inner padding. */
::v-deep .v-input__slot {
    border-radius: 12px !important;
}
.search-submit {
    border-radius: 12px;
}
/* On phones the fields stack, so the reserved message row and the full column
   padding add up to a large gap between them. */
@media (max-width: 599px) {
    ::v-deep .v-text-field__details {
        display: none;
    }
    .row > * {
        padding-top: 4px;
        padding-bottom: 4px;
    }
    /* The submit sits apart from the inputs it acts on, and matches their
       height so the stack reads as one control group. */
    .search-submit {
        margin-top: 12px;
    }
}
/* The hero heading is text-h3 (48px), which needs six lines on a phone. Scale
   it down below sm only — desktop keeps the size it has always had. */
@media (max-width: 599px) {
    .search-hero__title {
        font-size: 1.75rem !important;
        line-height: 1.3 !important;
        margin: 8px 0;
    }
}
</style>
